import type { FileMetadata, FingerprintImageMetadata } from '@cnapse/shared/schemas.js';
import type * as dt from '@cnapse/shared/data.types.js';
import type { WaferImageHistoryItem } from '../types/files';

/** Map image-history API rows to FileMetadata stored in parent form state (no preview URLs). */
export function waferHistoryToFileMetadata(item: WaferImageHistoryItem): FileMetadata & { fileId: number } {
  return {
    fileId: item.fileId,
    objectKey: item.objectKey,
    originalName: item.originalName,
    mimeType: item.mimeType,
    size: item.size,
    uploadedAt: item.uploadedAt,
  };
}

/** Full fingerprint metadata for FingerprintManager (OCR history fields). */
export function waferHistoryToFingerprintMetadata(
  item: WaferImageHistoryItem,
): FingerprintImageMetadata {
  return {
    ...waferHistoryToFileMetadata(item),
    fileId: item.fileId as dt.IntegerId,
  };
}
